module.exports = "/_next/static/images/robotImage-b46cfcc07da564b311b94dd091d938ca.png";